import {
    exceedsAiAgentSizeCap,
    fileToDataUrl,
    isAiAgentDocumentFile,
    isAiAgentVisionImage,
} from './fileToDataUrl';
import type {PendingChatAttachment} from '../../aiMessageGenerator/utils/types';

export type AttachmentUploadError = 'unsupported' | 'tooLarge';

type AttachmentUploadResult = {
    /** data:image/...;base64 — the server sends it to the model as a vision image. */
    imageDataUrl?: string;
    /** data:application/pdf;base64 — the server sends it to the model as a document. */
    fileDataUrl?: string;
    fileName?: string;
    error?: AttachmentUploadError;
};

export async function resolveAttachmentUpload(
    attachment: PendingChatAttachment | null | undefined,
): Promise<AttachmentUploadResult> {
    const file = attachment?.file;
    if(!file) {
        return {};
    }
    const isImage = isAiAgentVisionImage(file);
    // Deliberately narrower than isAiAgentSupportedFile: an HEIC that skipped conversion
    // must fail loudly here — sent as fileDataUrl it would only earn a silent server 400.
    if(!isImage && !isAiAgentDocumentFile(file)) {
        return {error: 'unsupported'};
    }
    if(exceedsAiAgentSizeCap(file)) {
        return {error: 'tooLarge'};
    }
    try {
        const dataUrl = await fileToDataUrl(file);
        return isImage
            ? {imageDataUrl: dataUrl}
            : {fileDataUrl: dataUrl, fileName: file.name};
    } catch {
        return {error: 'unsupported'};
    }
}
